import classNames from 'classnames';

const TableHeader = ({ children, extraClassNames, style }) => {
  return (
    <thead
      className={classNames('c-table__header', extraClassNames)}
      style={style}
    >
      {children}
    </thead>
  );
};

export default TableHeader;
